import React from 'react'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import useMediaQuery from '../../../hooks/useMediaQuery'
import ChatsDesktopView from './ChatsDesktopView'
import NewChatV2 from './chatV2'
import type { ChatViewMode } from './ChatListSh'

const NewChatV2Sh = (): JSX.Element => {
    const { pathname } = useLocation()
    const { id: chatId } = useParams()
    const isDesktop = useMediaQuery('(min-width: 992px)')
    const isWithSidebar = isDesktop && pathname.startsWith('/landlord')


    const [searchParams] = useSearchParams()

    const mode: ChatViewMode =
        searchParams.get('mode') === 'observer'
            ? 'observer'
            : 'admin'

    // console.log(mode, "mode <<< mode")


    return isWithSidebar
        ? <ChatsDesktopView chatId={chatId} mode={mode} />
        : <NewChatV2 isAdminMode={mode === 'admin'} />
}

export default NewChatV2Sh
